<template>
  <v-row justify="center">
    <v-dialog v-model="value" @input="$emit('input')" width="600px">
      <v-card>
        <v-card-title
          class="grey lighten-2"
          primary-title
        >
          <span class="headline" style="font-size:1.3rem!important">Projected COGS</span>
          <v-spacer></v-spacer>
          <v-icon @click="close">close</v-icon>
        </v-card-title>
        <v-card-text style="padding: 10px">
          <v-data-table
            dense
            :headers="headers"
            :search="filter"
            :items="monthYearValues"
            :key="dataTableKey"
            hide-default-footer
            :items-per-page="-1"
            class="recognized-revenue-table elevation-1">
            <template v-slot:[`item.month`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.month">{{item.month}}</span>
              </td>
            </template>
            <template v-slot:[`item.totalAmt`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.totalAmt">${{item.totalAmt | thousandSeprator}}</span>
              </td>
            </template>
            <template v-slot:[`item.amount`]="{ item }">
              <td class="text-start" style="min-width:100px!important">
                <span v-if="item.amount">${{item.amount | thousandSeprator}}</span>
              </td>
            </template>
            <template slot="body.append">
              <tr>
                <th style="font-size:14px"><b>Total</b></th>
                <th style="font-size:14px"><b>${{ totalCogsAmount | thousandSeprator }}</b></th>
                <th style="font-size:14px"><b>${{ totalAmount | thousandSeprator }}</b></th>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import moment from 'moment'
export default {
  name: 'RecognizedRevenueModal',
  props: [
    'value',
    'monthYearValues'
  ],
  data() {
    return {
      AMCC: [],
      selectedFilter: {
        AMCC: ''
      },
      headers: [
        {
          text: 'Month',
          value: 'month'
        },
        {
          text: 'Total Amount',
          value: 'totalAmt'
        },
        {
          text: 'Pending Amount',
          value: 'amount'
        }
      ],
      filteredMthYearVals: []
    }
  },
  computed: {
    currentYear: function() {
      return moment().format('YYYY')
    },
    totalAmount: function() {
      let total = 0
      if (this.monthYearValues) {
        this.monthYearValues.map(m => {
          if (m.amount) {
            total += parseFloat(m.amount)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    },
    totalCogsAmount: function() {
      let total = 0
      if (this.monthYearValues) {
        this.monthYearValues.map(m => {
          if (m.totalAmt) {
            total += parseFloat(m.totalAmt)
          }
        })
      }
      return parseFloat(total).toFixed(2)
    }
  },
  methods: {
    close() {
      this.$emit('input');
    }
  }
}
</script>
<style scoped>
  .autocomplete-filter {
    max-width: 200px;
  }
</style>



// WEBPACK FOOTER //
// ProjectedCogsModal.vue?23a95090